<alert type="danger" *ngIf="(alertMsg | async) as message">
  {{message}}
</alert>
